import { ButtonType } from 'modules/ui';
import { useTranslation } from 'react-i18next';
import React from 'react';
import { ChoiceButtonContainer } from './ChoiceButtonContainer';
import { StyledChoiceButton, StyledInfoIconButton } from './styled';
import { NavigationAndActionInfoSmall } from '../../../../ui/icons';

export interface ChoiceButtonProps {
  onSubmit?: () => void;
  text?: string;
  centered?: boolean;
  rightAligned?: boolean;
  titleText?: string;
}

export const ChoiceButton: React.FC<ChoiceButtonProps> = ({
  onSubmit,
  text,
  centered,
  rightAligned,
  titleText,
}) => {
  const { t } = useTranslation();

  return (
    <ChoiceButtonContainer
      maxWidth="60%"
      centered={centered}
      rightAligned={rightAligned}>
      <div style={{ width: '100%', display: 'flex' }}>
        <StyledChoiceButton
          text={text ?? t('form.formButtons.nextStep')}
          type={ButtonType.Primary}
          submit={!onSubmit}
          onClick={onSubmit}
        />
        <StyledInfoIconButton title={titleText}>
          <NavigationAndActionInfoSmall />
        </StyledInfoIconButton>
      </div>
    </ChoiceButtonContainer>
  );
};
